// extracted by mini-css-extract-plugin
module.exports = {"cardWrapper":"styles_cardWrapper__5hibJ","image":"styles_image__2xBdB","contentWrapper":"styles_contentWrapper__jGqSb","notificationTooltip":"styles_notificationTooltip__2bPzV"};